import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"
import HeaderComponent from "./HeaderComponent"
import MainComponent from "./MainComponent"
import SweepDisplayComponent from "./SweepDisplayComponent"
import VerifyComponent from "./VerifyComponent"
import FooterComponent from "./FooterComponent"
import UnsubscribeComponent from "./UnsubscribeComponent"
import ContactComponent from "./ContactComponent"

export default function StreetSweepingApp() {
    return (
        <div className="StreetSweepingApp container">
            <BrowserRouter>
                <HeaderComponent></HeaderComponent>
                
                <Routes>
                    <Route path='/' element={<Navigate to="/home" replace />}></Route>
                    <Route path="/home" element={<MainComponent></MainComponent>} />
                    <Route path='/contact' element={<ContactComponent></ContactComponent>}></Route>
                    <Route path='/showsweeps' element={<SweepDisplayComponent></SweepDisplayComponent>}></Route>
                    <Route path='/verify' element={<VerifyComponent></VerifyComponent>}></Route>
                    <Route path='/unsubscribe' element={<UnsubscribeComponent></UnsubscribeComponent>}></Route>
                </Routes>
      
                <FooterComponent></FooterComponent>
            </BrowserRouter>

        </div>)



}
